import styles from './index.module.sass';
import { Switch, Tooltip } from 'antd';
import classNames from 'classnames';

export const BuyerItem = ({
  checked,
  type,
  label,
  active,
  onClick,
  onSwitchChange,
  loading,
  distance,
  activeTrades,
}: IBuyerItem) => {
  function truncateLabel(label: string) {
    if (label.length > 35) {
      return label.slice(0, 32) + '...';
    }
    return label;
  }
  return (
    <li className={classNames(styles.root, active && styles.rootActive)}>
      <Switch
        onChange={(e) => onSwitchChange(e)}
        className={styles.switch}
        checked={checked}
        loading={loading}
      />
      <div className={styles.itemBody} onClick={onClick}>
        <div className={styles.info}>
          <span className={classNames(styles.label, active && styles.labelActive)}>
            {String(label).length > 35 ? (
              <Tooltip title={label}>{truncateLabel(label)}</Tooltip>
            ) : (
              label
            )}
          </span>
          {activeTrades > 0 && (
            <span className={styles.hasTrades}>
              {' '}
              <span className={styles.countCircle}>
                {activeTrades > 9 ? '9+' : activeTrades}
              </span>{' '}
              участвует в сделке{' '}
            </span>
          )}
        </div>

        <span
          className={classNames(styles.type, type === 'internal' && styles.typeActive)}
        >
          {type === 'internal' ? 'ваш контрагент' : 'внешний контрагент'}
        </span>
        {/* <span className={classNames(styles.distance)}>{distance} км</span> */}
      </div>
    </li>
  );
};

interface IBuyerItem {
  checked?: boolean;
  type: 'internal' | 'external';
  label: string;
  active?: boolean;
  onClick: () => void;
  onSwitchChange: (val: boolean) => void;
  loading: boolean;
  distance: number;
  activeTrades: number;
}
